import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'

function Description(props){
  const [productDescription] = useEnvValue('productDescription','')

  if(productDescription.length < 1) return null

  return (
    <div className="product_description" dangerouslySetInnerHTML={{ __html: productDescription}}></div>
  )
}

export default Description